/*
 * Public API Surface of ngx-filepond
 */

export * from './lib/ngx-filepond.component';
export * from './lib/ngx-filepond.module';
